// "New template" as a page, not a dialog asking only for a name.
//
// This loses nothing to being pre-creation: every card works off form state
// before the template exists, no saved row required. Create posts it and
// hands over to the template's page.

import { createFileRoute } from "@tanstack/react-router";
import { CreateTemplatePage } from "@/features/templates/create-template-page";

export const Route = createFileRoute("/w/$workspaceId/templates/new")({
    component: NewTemplatePage,
});

function NewTemplatePage() {
    const { workspaceId } = Route.useParams();
    return <CreateTemplatePage workspaceId={workspaceId} />;
}
